// React Compoment
import { MsalProvider } from '@azure/msal-react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

// My Compoment
import App from './App'
import { MsalRedirectHandler } from './auth/MsalRedirectHandler'
import { msalInstance } from './auth/msalInstance'
import reportWebVitals from './reportWebVitals'
import './assets/css/App.css'
import './styles/modern-theme.css'


// Store
import { persistor, store } from './stores'

/** CookieYes — chargé uniquement hors dev local (localhost non enregistré sur CookieYes). */
if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'local') {
    const cookieYes = document.createElement('script')
    cookieYes.id = 'cookieyes'
    cookieYes.type = 'text/javascript'
    cookieYes.src = 'https://cdn-cookieyes.com/client_data/89f6e54cf2db96e94588a747/script.js'
    document.head.appendChild(cookieYes)
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

void msalInstance.initialize().then(() => {
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <MsalRedirectHandler />
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <App />
                    </PersistGate>
                </Provider>
            </MsalProvider>
        </React.StrictMode>
    )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
